"use client";
import dynamic from "next/dynamic";
import { ADMIN_APP_TOKEN_ID } from "@chatsystem/common/config";
import { MARKETING_WIDGET_RUNTIME_KEY } from "@/modules/chat/widgetRuntimeIdentity";

const App = dynamic(() => import("@chatsystem/client").then((mod) => mod.App), {
  ssr: false,
});

export default function LauncherChatWrapper() {
  return (
    <div>
      <App
        key={MARKETING_WIDGET_RUNTIME_KEY}
        appToken={ADMIN_APP_TOKEN_ID}
      />
    </div>
  );
}
